import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { DeclaracaoSaudePerguntasViewModel } from "src/app/api/model/conta/proposta-externa/declaracao-saude/declaracaoSaudePerguntasVM";

@Injectable({
  providedIn: "root",
})
export class PerguntasDecalaracaoSaudeService {

  perguntasDeclaracaoSaude(): Observable<DeclaracaoSaudePerguntasViewModel[]> {
    return of([
      {
        codeQuestion: 1,
        exibir: true,
        questionText: 'Possui doenças do aparelho cardiocirculatório?',
        iconPath: '../../../../../assets/app-assets/images/icones-geia/declaracao-saude/coracao.png',
        description: 'São doenças que afetam o coração e vasos sanguíneos, como por exemplo: angina, arritmia,  febre reumática e/ou insuficiência cardíaca, hipertensão arterial (pressão alta), aneurisma, acidente vascular cerebral, doença arterial, coronariana e alterações em válvulas cardíacas.'
      },
      {
        codeQuestion: 2,
        exibir: true,
        questionText: 'Possui doenças das veias ou artérias?',
        iconPath: '../../../../../assets/app-assets/images/icones-geia/declaracao-saude/veias.png',
        description: 'São doenças que afetam os vasos sanguíneos, ou seja, interferem na circulação do sangue em nosso corpo, como por exemplo: hemorroidas, varizes, trombose, insuficiência venosa periférica, entre outras.'
      },
      {
        codeQuestion: 3,
        exibir: true,
        questionText: 'Possui doenças endócrinas?',
        iconPath: '../../../../../assets/app-assets/images/icones-geia/declaracao-saude/sistema-endocrino.png',
        description: 'São doenças que afetam o funcionamento de glândulas e consequentemente, acarretam outras alterações no organismo, como por exemplo: diabetes, tireoide, obesidade, hipotireoidismo ou hipertireoidismo e alterações na hipófise, entre outras.'
      },
      {
        codeQuestion: 4,
        exibir: true,
        questionText: 'Possui doenças pulmonares?',
        iconPath: '../../../../../assets/app-assets/images/icones-geia/declaracao-saude/pulmoes.png',
        description: 'São doenças que afetam os pulmões e outras estruturas ligadas a eles, como por exemplo: asma, bronquite, enfisema, pneumonia, doença pulmonar obstrutiva crônica, alterações respiratórias no sono (apneia) e tuberculose, entre outras.'
      },
      {
        codeQuestion: 5,
        exibir: true,
        questionText: 'Possui doenças do aparelho digestivo?',
        iconPath: '../../../../../assets/app-assets/images/icones-geia/declaracao-saude/sistema-digestivo.png',
        description: 'São doenças que podem afetar todo nosso sistema digestivo, isto é, desde a boca até os intestinos, como por exemplo: refluxo, gastrite, úlceras, cirrose, pancreatite, cálculos na vesícula, pancreatite, síndrome do intestino irritável, doença de crohn ou pólipos intestinais.'
      },
      {
        codeQuestion: 6,
        exibir: true,
        questionText: 'Possui hérnias?',
        iconPath: '../../../../../assets/app-assets/images/icones-geia/declaracao-saude/hernia-iguinal.png',
        description: 'É o deslocamento ou parte mais elevada de um órgão ou tecido através de uma abertura muscular, em uma região do corpo. Exemplo: hérnia de hiato, hérnia umbilical, hérnia femoral, hérnia muscular, hérnia de disco e outras.'
      },
      {
        codeQuestion: 7,
        exibir: true,
        questionText: 'Possui doenças renais ou de bexiga?',
        iconPath: '../../../../../assets/app-assets/images/icones-geia/declaracao-saude/urinario.png',
        description: 'São alterações que afetam a função dos rins e da bexiga, impactando na filtração de todo sangue do organismo, como nos casos de: insuficiência renal, pielonefrite, cálculos renais (pedras) e incontinência urinária'
      },
      //masculino
      {
        codeQuestion: 8,
        exibir: true,
        questionText: 'Possui doenças dos órgãos genitais masculinos?',
        iconPath: '../../../../../assets/app-assets/images/icones-geia/declaracao-saude/orgao.png',
        description: 'Trata-se de doenças que causam alterações que podem ser estruturais e afetam o funcionamento destes órgãos, como: aumento da próstata, tumores malignos, fimose, hidrocele e infecções urinárias recorrentes.'
      },
      //feminino
      {
        codeQuestion: 9,
        exibir: true,
        questionText: 'Possui doenças ginecológicas e das mamas?',
        iconPath: '../../../../../assets/app-assets/images/icones-geia/declaracao-saude/mulher.png',
        description: 'Trata-se de doenças que causam alterações que podem ser estruturais e afetam o funcionamento de órgãos como: útero, ovários, trompas, colo do útero e mamas. Exemplos destas alterações são: inflamações, infecções, infertilidade, pólipos e tumores.'
      },
      {
        codeQuestion: 10,
        exibir: true,
        questionText: 'Possui AIDS ou é portador do vírus HIV?',
        iconPath: '../../../../../assets/app-assets/images/icones-geia/declaracao-saude/tubo-de-ensaio.png',
        description: 'Informar se possui conhecimento de que é portador do vírus do HIV ou sofre de AIDS (onde várias outras doenças podem se instalar em decorrência da baixa imunidade do vírus HIV).'
      },
      {
        codeQuestion: 11,
        exibir: true,
        questionText: 'Possui doenças do sangue?',
        iconPath: '../../../../../assets/app-assets/images/icones-geia/declaracao-saude/teste-de-sangue.png',
        description: 'São doenças que causam alterações sanguíneas e consequentemente em outras funções de nosso organismo, dentre elas: doenças hemorrágicas, anemia e mielopatia, leucemia, síndromes mielodisplásicas.'
      },
      {
        codeQuestion: 12,
        exibir: true,
        questionText: 'Possui doenças e/ou tumorações malignas ou benignas?',
        iconPath: '../../../../../assets/app-assets/images/icones-geia/declaracao-saude/carcinoma.png',
        description: 'Informar caso possua o diagnóstico conhecido de quaisquer tumorações malignas ou benignas atualmente ou anteriormente.'
      },
      {
        codeQuestion: 13,
        exibir: true,
        questionText: 'Possui doenças reumáticas?',
        iconPath: '../../../../../assets/app-assets/images/icones-geia/declaracao-saude/dor.png',
        description: 'É o conjunto de diferentes doenças que acometem o aparelho locomotor, ou seja, ossos, articulações, cartilagens, músculos, tendões e ligamentos. Dentre elas estão: artrose, fibromialgia, osteoporose, gota, tendinite e bursite.'
      },
      {
        codeQuestion: 14,
        exibir: true,
        questionText: 'Possui doenças neurológicas?',
        iconPath: '../../../../../assets/app-assets/images/icones-geia/declaracao-saude/neurologia.png',
        description: 'São doenças que acometem o sistema nervoso central, como por exemplo: derrame, alzheimer e esclerose múltipla.'
      },
      {
        codeQuestion: 15,
        exibir: true,
        questionText: 'Possui doenças de pele?',
        iconPath: '../../../../../assets/app-assets/images/icones-geia/declaracao-saude/doenca-de-pele.png',
        description: 'São alterações causadas na derme e epiderme (camadas da pele) que podem ocorrer em qualquer parte do corpo, como por exemplo: abcessos, vitiligo, cistos, desidrose e psoríase.'
      },
      {
        codeQuestion: 16,
        exibir: true,
        questionText: 'Possui doenças infecto contagiosas?',
        iconPath: '../../../../../assets/app-assets/images/icones-geia/declaracao-saude/infectado.png',
        description: 'São doenças que podem ser transmitidas de um indivíduo para o outro, através de contato direto e indireto, como por exemplo: infecções sexualmente transmissíveis, hanseníase, febre amarela, dengue, zika vírus e chikungunya.'
      },
      {
        codeQuestion: 17,
        exibir: true,
        questionText: 'Possui problemas ortopédicos?',
        iconPath: '../../../../../assets/app-assets/images/icones-geia/declaracao-saude/ortopedista.png',
        description: 'Trata-se de alterações que envolvem o sistema locomotor (ossos, ligamentos e tendões), como por exemplo: ruptura de ligamentos, pé torto congênito, lombalgia, síndrome do túnel do carpo e hérnia de disco lombar.'
      },
      {
        codeQuestion: 18,
        exibir: true,
        questionText: 'Possui doenças ou malformações congênitas ou hereditárias?',
        iconPath: '../../../../../assets/app-assets/images/icones-geia/declaracao-saude/dna.png',
        description: 'São doenças que já se apresentam desde o nascimento do bebê ou podem ser detectadas durante a gravidez, como: síndrome de down, de turner, de edwards, defeitos abertos do tubo neural e fibrose cística.'
      },
      {
        codeQuestion: 19,
        exibir: true,
        questionText: 'Possui doenças dos olhos?',
        iconPath: '../../../../../assets/app-assets/images/icones-geia/declaracao-saude/olho.png',
        description: 'São alterações visuais que podem ser causadas por diversos motivos. Podem se desenvolver desde a infância ou ao longo da vida, decorrente do processo de envelhecimento. Sendo algumas delas: catarata, terçolho, blefarite, astigmatismo, hipermetropia, miopia e olho seco.'
      },
      {
        codeQuestion: 20,
        exibir: true,
        questionText: 'Possui doenças dos ouvidos, nariz e garganta?',
        iconPath: '../../../../../assets/app-assets/images/icones-geia/declaracao-saude/orelha.png',
        description: 'Para esta classificação temos alguns exemplos, como: perda de audição, zumbido, otite crônica, sinusite, rinite, amigdalite ou paralisia das cordas vocais.'
      },
      {
        codeQuestion: 21,
        exibir: true,
        questionText: 'Possui transtornos mentais ou psiquiátricos?',
        iconPath: '../../../../../assets/app-assets/images/icones-geia/declaracao-saude/saude-mental.png',
        description: 'São alterações do funcionamento da mente que prejudicam o desempenho da vida de uma pessoa em âmbitos familiar, social e pessoal, como: ansiedade, bipolaridade, síndrome do pânico, autismo (TEA) e/ou transtornos psicológicos em geral.'
      },
      {
        codeQuestion: 22,
        exibir: true,
        questionText: 'Sofre de alguma dependência química?',
        iconPath: '../../../../../assets/app-assets/images/icones-geia/declaracao-saude/comprimidos.png',
        description: 'Informar se faz uso regular que alguma substância que cause dependência em seu organismo, como: tabaco, álcool ou medicamentos (calmante).'
      },
      {
        codeQuestion: 23,
        exibir: true,
        questionText: 'Já foi submetido a hemodiálise, radioterapia, quimioterapia?',
        iconPath: '../../../../../assets/app-assets/images/icones-geia/declaracao-saude/quimioterapia.png',
        description: 'Informar se em algum momento de sua vida já necessitou realizar algum dos tratamentos citados. Se sim, informar a quantidade de sessões, motivo e tempo que permaneceu em tratamento.'
      },
      {
        codeQuestion: 24,
        exibir: true,
        questionText: 'Já foi internado ou submetido a algum tratamento não mencionado acima?',
        iconPath: '../../../../../assets/app-assets/images/icones-geia/declaracao-saude/diagnostico.png',
        description: 'Se sim, informar se em algum momento de sua vida já necessitou realizar algum tratamento como: abordagens cirúrgicas (por qualquer motivo), internações clínicas ou terapias psicológicas'
      },
      //feminino
      {
        codeQuestion: 25,
        exibir: true,
        questionText: 'Está grávida?',
        iconPath: '../../../../../assets/app-assets/images/icones-geia/declaracao-saude/gravidez.png',
        description: 'Se sim, informar a idade/tempo gestacional e se trata-se de uma gestação de feto único ou gemelar.'
      },
      {
        codeQuestion: 26,
        exibir: true,
        questionText: 'Sofre de alguma doença ou faz algum tratamento não mencionado acima?',
        iconPath: '../../../../../assets/app-assets/images/icones-geia/declaracao-saude/febre.png',
        description: 'Sofre de alguma doença ou faz algum tratamento não mencionado nas questões anteriores?'
      },
      {
        codeQuestion: 27,
        exibir: true,
        questionText: 'Informe sua altura',//somente para maior de idade
        iconPath: '../../../../../assets/app-assets/images/icones-geia/declaracao-saude/altura.png',
        description: 'Digite o valor em metros.'
      },
      {
        codeQuestion: 28,
        exibir: true,
        questionText: 'Informe seu peso',//somente para maior de idade
        iconPath: '../../../../../assets/app-assets/images/icones-geia/declaracao-saude/balanca.png',
        description: 'Digite o valor em Kg.'
      },
    ])
  }
}
